import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Modal, Button, Form, notification, Col, Row } from "antd";

import FloatInput from "../../../../providers/FloatInput";
import { POST, GET } from "../../../../providers/useAxiosQuery";
import validateRules from "../../../../providers/validateRules";
import FloatInputMask from "../../../../providers/FloatInputMask";
import FloatSelect from "../../../../providers/FloatSelect";

export default function ModaleEditDepartment(props) {
	const { toggleModalEditDepartment, setToggleModalEditDepartments } = props;

	// console.log("course", course);
	// console.log("role", role);
	const [form] = Form.useForm();
	const params = useParams();

	const { mutate: mutateEmail, loading: loadingEmail } = POST(
		`api/ref_departments`,
		[`edit_departments_${toggleModalEditDepartment.id}`]
	);

	const onFinish = (values) => {
		console.log("onFinish", values);

		let data = {
			...values,

			id:
				toggleModalEditDepartment &&
				toggleModalEditDepartment.data &&
				toggleModalEditDepartment.data.id,

			// book_id: toggleModalEditAuthor.book_id,
		};

		mutateEmail(data, {
			onSuccess: (res) => {
				if (res.success) {
					notification.success({
						message: "Author Added",
						description: res.message,
					});

					setToggleModalEditDepartments({ open: false, data: null });

					form.resetFields();
				} else {
					notification.error({
						message: "Something went wrong",
						description: res.message,
					});
				}
			},
			onError: (err) => {
				notification.error({
					message: "Author not successfully Added",
					description: "Something went Wrong",
				});
			},
		});
	};

	useEffect(() => {
		if (toggleModalEditDepartment.open) {
			if (toggleModalEditDepartment.data) {
				let data = {
					...toggleModalEditDepartment.data,
					// email: toggleModalEditCourse.data.user.email,
				};
				form.setFieldsValue(data);
			}
		}

		return () => {};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [toggleModalEditDepartment]);

	return (
		<Modal
			title="Edit Department"
			open={toggleModalEditDepartment.open}
			onCancel={() => {
				setToggleModalEditDepartments({
					open: false,
					data: null,
				});
			}}
			footer={[
				<Button
					className="btn-main-primary outlined"
					size="large"
					key={1}
					onClick={() => {
						setToggleModalEditDepartments({
							open: false,
							data: null,
						});
						form.resetFields();
					}}
				>
					CANCEL
				</Button>,
				<Button
					className="btn-main-primary"
					type="primary"
					size="large"
					key={2}
					onClick={(values) => form.submit(values)}
					loading={loadingEmail}
				>
					SUBMIT
				</Button>,
			]}
		>
			<Form form={form} onFinish={onFinish}>
				<Form.Item name="department_name">
					<FloatInput label="Department" placeholder="Department" required />
				</Form.Item>
			</Form>
		</Modal>
	);
}
